import React from 'react';
import {Dot, ArrowRight, CheckCircle, QuestionFill, EmojiFrown, Pen} from '../../../components/tools/Icons'
import uiHelpers from '../../../helpers/uiHelpers';
import serviceUrls from '../../../constants/serviceUrls';
import * as apiCaller from '../../../helpers/apiCaller'
import {  converters } from '../../../helpers/converters';
import { Link } from "react-router-dom";
import MeterCommissionHeading from './common/MeterCommissionHeading';
import { LoadingPage } from '../../../components/tools/Others';
import MeterCommissionAudits from './common/MeterCommissionAudits';
import { userRole, addUserRoleUpdateNotifier } from '../../../helpers/userHelpers';
import MeterCommissionAdmin from './common/MeterCommissionAdmin';
import MeterCommissionConsent from './common/MeterCommissionConsent';
import { getLidInstallationForm, getSimCardChangeForm } from '../forms/LidInstallationForm';
import MeterCommissionMeterDetails from './common/MeterCommissionMeterDetails';
import MeterCommissionSimActivations from './common/MeterCommissionSimActivations';
import SimActivationProcess from '../../simActivationProcess/SimActivationProcess';


const initState = {
    view:'MAIN',
    initialised:false,
    noPermission: false,
    adminTab:false,
    cdoTab:false,
    originalVendor:null,
    confirmingSave:false,
    vendorChangedSuccessfully:false,
    simActivation:null,
    modifyingIccid:false,
    revertingIccid:false
}

class LidInstallation  extends React.Component {

    meterCommissionId;
    lidInstallationForm;
    simCardChangeForm;

    constructor(props) {
        super(props);
        this.state = JSON.parse(JSON.stringify(initState));
        this.lidInstallationForm = getLidInstallationForm('lidIntallationForm',this);
        this.simCardChangeForm = getSimCardChangeForm('simCardChangeForm',this,this.saveSimChange, this.revertSim);
        this.meterCommissionId = parseInt(props.match.params.id);
    }


    async componentDidMount() {
        addUserRoleUpdateNotifier(this.userRolesUpdated);
        if(!this.meterCommissionId) return;
        this.refreshPage();
    }

    userRolesUpdated = () => {
        if (userRole.isSuperAdmin) {
            this.setState({ adminTab:true});
        }
        if(userRole.isCDO) {
            this.setState({ cdoTab:true});
        }
    }

    refreshPage = async () => {
        uiHelpers.showProgressOnTop('Please wait...');
        this.lidInstallationForm.disableForm();
        await apiCaller.post(serviceUrls.meterCommission.getMeterCommissionLidRegistration,{id:this.meterCommissionId})
        .then(this.wholePageDataBind).finally(this.wholePageAfterRefresh);
    }

    saveSimChange = async () => {
        this.simCardChangeForm.disableForm();
        uiHelpers.showProgressOnTop('Saving...');
        await apiCaller.post(serviceUrls.meterCommission.adminModifySim,{id:this.meterCommissionId,simCardChangeForm:this.simCardChangeForm.vals()})
        .then(this.wholePageDataBind).finally(this.wholePageAfterRefresh);
    }

    revertSim = async () => {
        this.simCardChangeForm.disableForm();
        uiHelpers.showProgressOnTop('Reverting...');
        await apiCaller.post(serviceUrls.meterCommission.adminRevertSim,{id:this.meterCommissionId,simCardChangeForm:this.simCardChangeForm.vals()})
        .then(this.wholePageDataBind).finally(this.wholePageAfterRefresh);
    }

    changeLidVendor = async () => {
        uiHelpers.showProgressOnTop('Please wait...');
        this.lidInstallationForm.disableForm();
        await apiCaller.post(serviceUrls.meterCommission.changeLidVendorLidRegistration,{id:this.meterCommissionId, newLidVendorId: this.lidInstallationForm.val("lidVendor").id})
        .then((data)=>this.wholePageDataBind(data,()=>{
            this.setState({vendorChangedSuccessfully:true})
        })).finally(this.wholePageAfterRefresh);
    }

    wholePageDataBind = (data, callback=null) =>{
        if(data.userNoPermission) this.setState({initialised:true, noPermission:true});
        else {
            const newState = JSON.parse(JSON.stringify(initState));
            newState.role = data.role;
            newState.meterCommission = data.meterCommission;
            newState.initialised = true;
            newState.audits = data.audits;
            newState.view = this.state.view;
            newState.adminTab = userRole.isSuperAdmin;
            newState.cdoTab = userRole.isCDO;
            newState.originalVendor = data.lidInstallationForm.fields.lidVendor;
            newState.simActivation = data.simActivation;
            
            this.setState(newState,()=>{

                this.lidInstallationForm.vals(data.lidInstallationForm.fields, false);
                this.lidInstallationForm.setOptions(data.lidInstallationForm.optionsForFields, false);
                
                this.simCardChangeForm.vals(data.simCardChangeForm.fields,false);
                this.simCardChangeForm.setOptions(data.simCardChangeForm.optionsForFields, false);
                this.simCardChangeForm.enableForm(()=>{
                    if(this.lidInstallationForm.val("lidInstallationStatus") == "REJECTED" ) this.lidInstallationForm.enableField("lidVendor",false);
                    if(data.meterCommission.status == 'PENDING_LID_REGISTRATION' && this.state.role=="OWNER") {
                        this.lidInstallationForm.enableForm(callback);
                    } else {
                        this.lidInstallationForm.disableForm(callback);
                    } 
                });
            })
        }
    }

    wholePageAfterRefresh = () => {
        uiHelpers.hideProgressOnTop();
    }

    onCancelClick = () => {
        this.refreshPage();
    }

    onSaveClick = () => {
        this.setState({confirmingSave:true},()=>this.lidInstallationForm.disableField("lidVendor"))
    }


    render() {
        if(!this.meterCommissionId) return <div className='alert alert-danger'>You access this page incorrectly</div>
        if(!this.state.initialised) return <LoadingPage />;
        if(this.state.noPermission) return <div className='alert alert-danger'>Access denied.</div>

        const form = this.lidInstallationForm;
        const simCardChangeForm = this.simCardChangeForm;
        const getExistingLidLable = (o)=>
            <div className="text-truncate">This LID is connecting to {o.meters.map((m,i)=>{
                if(i==0) return <><strong className='text-primary fs-80'>{m.meterSiteId}</strong></>;
                return <>, <strong className='text-primary fs-80'>{m.meterSiteId}</strong></>;
            })}
        </div>;
        return <>

            <MeterCommissionHeading 
                meterCommission={this.state.meterCommission} 
                role={this.state.role} 
                refreshPage={this.refreshPage}
            />

            <div className='mb-3'>
                <ul className="nav nav-pills">
                    <li className="nav-item">
                        <a onClick={(e)=>{e.preventDefault();this.setState({view:'CONSENT'})}} className={`nav-link ${this.state.view=='CONSENT'?'active':''}`} href="#">Customer Authorisation</a>
                    </li>
                    <li className="nav-item">
                        <a onClick={(e)=>{e.preventDefault();this.setState({view:'MAIN'});}} className={`nav-link ${this.state.view=='MAIN'?'active':''}`}  href="#">Process Details</a>
                    </li>
                    {this.state.simActivation && (this.state.adminTab || this.state.cdoTab) && <>
                        <li className="nav-item">
                            <a onClick={(e)=>{e.preventDefault();this.setState({view:'SIM_ACTIVATION'})}} className={`nav-link ${this.state.view=='SIM_ACTIVATION'?'active':''}`} href="#">
                                Sim Activation(s)
                            </a>
                        </li>
                    </>}
                    {this.state.meterCommission.meter && (this.state.adminTab || this.state.cdoTab) && <>
                        <li className="nav-item">
                            <a onClick={(e)=>{e.preventDefault();this.setState({view:'METER'})}} className={`nav-link ${this.state.view=='METER'?'active':''}`} href="#">Meter Details</a>
                        </li>
                    </>}
                    {this.state.role!="OWNER" && this.state.adminTab && <li className="nav-item">
                        <a onClick={(e)=>{e.preventDefault();this.setState({view:'ADMIN'})}} className={`nav-link ${this.state.view=='ADMIN'?'active':''}`} href="#">Admin</a>
                    </li>}
                    <li className="nav-item">
                        <a onClick={(e)=>{e.preventDefault();this.setState({view:'AUDIT'})}} className={`nav-link ${this.state.view=='AUDIT'?'active':''}`} href="#">Audit</a>
                    </li>
                </ul>
            </div>

            <hr/>
            {this.state.view=='AUDIT' ? <>
                <MeterCommissionAudits role={this.state.role} meterCommissionId={this.meterCommissionId}/>
            </> : this.state.view=='CONSENT' ? 
                <MeterCommissionConsent consent={this.state.meterCommission.consent}/> 
            : this.state.view=='SIM_ACTIVATION' ? 
                <MeterCommissionSimActivations meterCommissionId={this.meterCommissionId} />
            : this.state.view=='ADMIN' ? <>
                <MeterCommissionAdmin 
                    meterCommission={this.state.meterCommission} 
                    refreshPage={this.refreshPage} 
                    lid={form.val('lid')}
                    installationTypeKey= { form.vals().installationType ? form.vals().installationType.key:null}
                />
            </> : this.state.view=='METER' ? <>
                <MeterCommissionMeterDetails meter={this.state.meterCommission.meter} />
            </> : <>

                <div className='card mb-3'>
                    <div className='card-body py-1 fs-90'>
                        <span className='text-primary'><CheckCircle /> Find Approval &amp; Customer Authorisation</span> 
                        <span className='px-2'><ArrowRight/></span>

                        <CheckCircle /> <Link to={`/compliance-process/${this.state.meterCommission.id}/site-registration`}>Site Registration</Link>                        
                        <span className='px-2'><ArrowRight/></span>

                        {this.state.meterCommission.status=='PENDING_LID_REGISTRATION' ?  <Dot/> : <CheckCircle/>}
                        <strong className='text-primary'> LID Registration</strong>
                        {this.state.simActivation && this.state.simActivation.hasError && <span className='text-danger btn-icon-16'> <EmojiFrown /></span>}
                        <span className='px-2'><ArrowRight/></span>


                        {this.state.meterCommission.status=='COMPLETED' ?  <span className='text-primary'><CheckCircle/> </span> : <span className='text-primary'><Dot/> </span>}
                        {this.state.meterCommission.status=='PENDING_LID_REGISTRATION' ?
                            <i className='text-secondary fs-80'>Commissioning &amp; Validation</i>
                            :
                            <Link to={`/compliance-process/${this.state.meterCommission.id}/validation`}>Commissioning &amp; Validation</Link>                        
                        }
                    </div>
                </div>
                <div class="card mb-3">
                    <div class="card-header bg-primary text-white">
                        <b>LID Vendor</b>
                    </div>
                    <div className='card-body'>
                        {form.val('lidInstallationStatus') == 'REJECTED' ? 
                            form.renderDropDownRow('lidVendor',<>LID Vendor <span className='text-danger'>*</span></>,(o)=>o.id,o=>o.name,{rowClasses:'mb-3'})
                            :
                            form.renderUneditableTextInputRow('lidVendor',<>LID Vendor</>,{rowClasses:'mb-3', converter:o=>o.name})
                        }

                        {(this.state.originalVendor && form.val("lidVendor") && this.state.originalVendor.id != form.val("lidVendor").id ) &&  <>
                            {this.state.confirmingSave ? <div className='card border-primary border-1 mb-5 '>
                                <div className="card-body bg-primary bg-opacity-10 text-center">
                                    <p className="text-primary"><b>Please confirm that you would like to update the LID Vendor</b></p>
                                    <p className='fs-80'>Please note that a new email will be sent to the updated LID Vendor and the previous email with the link will be disabled.</p>
                                    <div>
                                        <button type="button" className="btn btn-secondary me-3" disabled={form.isFormDisabled()} onClick={this.onCancelClick}>Cancel</button>
                                        <button type="button" className="btn btn-primary" disabled={form.isFormDisabled()} onClick={this.changeLidVendor}>Confirm</button>
                                    </div>
                                </div>
                            </div>
                            : 
                            <div className='row'>
                                <div className='col-md-4'></div>
                                <div className='col-md-8'>
                                    <button className='btn btn-primary me-3' disabled={form.isFormDisabled()} onClick={this.onSaveClick}>Save</button>
                                    <button className='btn btn-secondary' onClick={this.onCancelClick} disabled={form.isFormDisabled()}>Cancel</button>
                                </div>
                            </div>}
                        </>}

                        {(form.val("lidInstallationStatus") == "REJECTED" && this.state.originalVendor && form.val("lidVendor") && this.state.originalVendor.id == form.val("lidVendor").id )  && <>

                            {this.state.confirmingSave ? <div className='card border-primary border-1 mb-5 '>
                                <div className="card-body bg-primary bg-opacity-10 text-center">
                                    <p className="text-primary"><b>Please confirm that you would like to update the LID Vendor</b></p>
                                    <p className='fs-80'>Please note that a new email will be sent to the updated LID Vendor and the previous email with the link will be disabled.</p>
                                    <div>
                                        <button type="button" className="btn btn-secondary me-3" disabled={form.isFormDisabled()} onClick={this.onCancelClick}>Cancel</button>
                                        <button type="button" className="btn btn-primary" disabled={form.isFormDisabled()} onClick={this.changeLidVendor}>Confirm</button>
                                    </div>
                                </div>
                            </div>
                            : 
                            <div className='row'>
                                <div className='col-md-4'></div>
                                <div className='col-md-8'>
                                    <button className='btn btn-primary me-3' disabled={form.isFormDisabled()} onClick={this.onSaveClick}>Resend</button>
                                </div>
                            </div>}

                        </>}

                        {this.state.vendorChangedSuccessfully && <div className='alert alert-success'>
                            Email is sent to LID vendor for LID Registration. Please check your email for further notifications.
                        </div>}
                        
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-header bg-primary text-white">
                        <b>LID Details</b>
                    </div>
                    <div className='card-body'>

                        {form.val("lidInstallationStatus") == "REJECTED" && <div className='alert alert-danger'>
                            <p>The LID Vendor has returned this form to you. Please update the LID Vendor.</p>
                            Comments from LID Vendor: {form.val('comments')}
                        </div>}

                        {form.val("lidInstallationStatus") == "PENDING_SUBMIT" && <div className='alert alert-primary'>
                            Pending for LID Vendor to provide LID details
                        </div>}

                        {form.val("lidInstallationStatus") == "ACCEPTED" && <div className='alert alert-primary'>
                            Pending for LID Vendor to do testing
                        </div>}

                        {form.renderUneditableTextInputRow('isLidTelemetry',<>Is the LID being used for Telemetry?</>,{rowClasses:'mb-3', converter:converters.common.converBoolToYesNo})}

                        {
                            form.val('isLidTelemetry')===true 
                            && 
                            form.renderUneditableTextInputRow('telemetryType',<>LID Telemetry Type</>,{rowClasses:'mb-3', converter:t=>t?t.name:null})
                        }
                        {form.renderUneditableTextInputRow('lid',<>LID Device</>,{rowClasses:'mb-3', converter:lid=>lid?lid.name:null})}

                        {form.renderUneditableTextInputRow("meterType",<>LID Type</>,{converter:o=>o && o.name,rowClasses:'mb-3'})}
                        {form.val('meterType') && form.val('meterType').key=='PULSE' && form.renderUneditableTextInputRow('meterScalingFactor',<>Scaling Factor (Multiplier)</>,{rowClasses:'mb-3'})}

                        {   
                            form.val('lid') && form.val('lid').allowMultiple 
                            &&
                            form.renderUneditableTextInputRow('isFirstMeterForLID',<>Is this the first meter registered to this LID?</>,{rowClasses:'mb-3', converter:converters.common.converBoolToYesNo})
                        }

                        {form.val('formVersion')>=5 && form.val('isLidTelemetry') === true && form.val('telemetryType') && form.val('telemetryType').key=='SIM' && <>
                            {!this.state.modifyingIccid && !this.state.revertingIccid && form.renderUneditableTextInputRow("iccid",<>Sim Card</>,{converter: o => <>
                                {this.state.simActivation && this.state.simActivation.hasError && (this.state.adminTab || this.state.cdoTab) && <>
                                    <button className='btn btn-outline-primary btn-sm me-3' onClick={()=>this.setState({modifyingIccid:true})}><Pen/></button>
                                    {form.val("iccidOriginal") && <button className='btn btn-outline-primary btn-sm me-3' onClick={()=>this.setState({revertingIccid:true})}>Revert</button>}
                                </>}

                                {form.val("iccidOriginal") && <span className='text-decoration-line-through text-muted me-2'>{form.val("iccidOriginal")}</span>}
                                {o.iccid} {o.label && <i className='text-muted fs-80'>({o.label})</i>}
                            </>,rowClasses:'mb-3'})}
                            {this.state.revertingIccid && <div className='card border-primary mb-3'>
                                <div class="card-header">
                                    <b>Revert SIM Card to LID Vendor Selection</b>
                                </div>
                                <div className='card-body'>
                                    {form.renderUneditableTextInputRow("iccid",<>Currently Selected</>,{converter: o => o.iccid,rowClasses:'mb-3'})}
                                    {form.renderUneditableTextInputRow("iccidOriginal",<>Reverting to</>,{rowClasses:'mb-3'})}
                                    <div class="row">
                                        <div class="col-md-4 py-2"></div>
                                        <div className="col-md-8">
                                            <button className='btn btn-primary me-2' disabled={simCardChangeForm.isFormDisabled()} onClick={()=>this.simCardChangeForm.runAction('revert')}>Confirm</button>
                                            <button className='btn btn-secondary' disabled={simCardChangeForm.isFormDisabled()} onClick={()=>this.setState({revertingIccid:false})}>Cancel</button>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>}
                            {this.state.modifyingIccid && <div className='card border-primary mb-3'>
                                <div class="card-header">
                                    <b>Modify SIM Card</b>
                                </div>
                                <div className='card-body'>

                                    {form.renderUneditableTextInputRow("iccid",<>Selected by LID Vender</>,{converter: o => <>
                                        {form.val("iccidOriginal") ? form.val("iccidOriginal") : <>{o.iccid} {o.label && <i className='text-muted fs-80'>({o.label})</i>}</>}
                                    </>,rowClasses:'mb-3'})}
                                    <div class="row">
                                        <div class="col-md-4 py-2">Changing to <span className='text-danger'>*</span></div>
                                        <div className="col-md-8">
                                            {simCardChangeForm.renderDropDown("iccid",(o) => o.iccid, (o) => <>{o.iccid} {o.label && <i className='text-muted fs-80'>({o.label})</i>}</>)}
                                            <div className='mt-3'>
                                                <button className='btn btn-primary me-2' disabled={simCardChangeForm.isFormDisabled()} onClick={()=>this.simCardChangeForm.runAction('save')}>Save</button>
                                                <button className='btn btn-secondary' disabled={simCardChangeForm.isFormDisabled()} onClick={()=>this.setState({modifyingIccid:false})}>Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                        </>}

                        {this.state.simActivation && this.state.simActivation.hasError && <div className='alert alert-danger'>
                            We have identified an issue during <b>SIM activation</b>. 
                            {(this.state.adminTab || this.state.cdoTab) ? " Please fix as it may affect LID testing." : " Please contact the system administrator to resolve this, as it may affect LID testing."}
                        </div>}

                        {form.val('isFirstMeterForLID') ===false && <>
                            {form.renderUneditableTextInputRow('existingLid',<>Existing LID </>,{rowClasses:'mb-3', converter:getExistingLidLable})}
                            {form.renderUneditableTextInputRow('existingLid',"LID Serial Number",{rowClasses:'mb-3',converter:value=>value?value.lidSerialNumber:null})}
                        </>}

                        {form.renderUneditableTextInputRow('comments',<>Comments</>,{rowClasses:'mb-3'})}

                        {form.renderUneditableTextInputRow('tested',<>LID to DAS Test Successful?</>,{rowClasses:'mb-3', converter:converters.common.converBoolToYesNo})}

                    </div>
                </div>


                {this.state.simActivation && (this.state.adminTab || this.state.cdoTab) && <>
                    <div class="card mb-3">
                        <div class="card-header bg-primary text-white">
                            <b>Current Sim Card Activation Process</b> 
                        </div>
                        <div className='card-body'>
                            <SimActivationProcess meterCommissionId={this.state.meterCommission.id} 
                                selectedIccidInMC = {form.val('iccid') ? form.val('iccid').iccid : null}
                                onHasErrFlagChanged={(hasError)=>{this.setState({simActivation: { hasError } })}} 
                            />
                        </div>
                    </div> 
                </>}

                {form.val("lidInstallationStatus") == 'COMPLETED' && <div className='text-end'>
                    <Link className="btn btn-success" to={`/compliance-process/${this.state.meterCommission.id}/validation`}>Next</Link>
                </div>}
                
                <div className='text-end fs-80 text-muted mt-5'><i>Form version: {form && form.val('formVersion')}</i></div>

            </>}
        </>
    }

    
}

export default LidInstallation;
